import { fromJS } from 'immutable';
import { combineReducers } from 'redux-immutable';
import { Boot as BootAction } from '@Actions';

export default combineReducers({
  config: (state = fromJS({}), { type, payload }) => {
    switch (type) {
      case BootAction.CONFIG_SUCCESS:
        return payload;
      default:
        return state;
    }
  },
});
